import useApi from '../hooks/useApi';
import ScrollReveal, { StaggerReveal, StaggerItem } from './ScrollReveal';

const MembreCard = ({ nom, role, photo_url }) => (
  <StaggerItem>
    <div className="card-minimal p-5 flex flex-col items-center text-center group hover:-translate-y-0.5 transition-transform duration-300">
      <div className="w-24 h-24 rounded-2xl overflow-hidden mb-4 ring-1 ring-stone-100 group-hover:ring-brand-200 transition-all bg-stone-100 flex items-center justify-center">
        {photo_url ? (
          <img src={photo_url} alt={nom} className="w-full h-full object-cover" />
        ) : (
          <span className="text-3xl font-bold text-stone-300">{nom?.[0]}</span>
        )}
      </div>
      <p className="font-semibold text-stone-950 text-sm mb-1">{nom}</p>
      <span className="tag tag-brand text-[11px]">{role}</span>
    </div>
  </StaggerItem>
);

const Bureau = () => {
  const { data: membres } = useApi('bureau');

  if (!membres.length) return null;

  return (
    <section className="section bg-stone-50">
      <div className="max-w-6xl mx-auto">
        <ScrollReveal className="mb-10">
          <span className="eyebrow mb-3 block">L'équipe dirigeante</span>
          <h2 className="display-md text-stone-950">Le Bureau</h2>
        </ScrollReveal>
        <StaggerReveal className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {membres.map(m => <MembreCard key={m.id} {...m} />)}
        </StaggerReveal>
      </div>
    </section>
  );
};

export default Bureau;
